import { on, select } from 'modules/dom'
import { getProp, setProp } from 'modules/utils'

export default function(el) {
    const INPUT_WEBINAR_GRADE = '.js-input-webinar-grade'
    const INPUT_RESOURCE_GRADE = '.js-input-resource-grade'
    const FORM_FILTER_SIDEBAR = '.js-filter-form'

    const body = document.body
    const selectEl = select('.js-select', el)
    const options = getProp('options', selectEl)
    const selectCurrentEl = select('.js-current', el)
    const currentURL = window.location.origin
    const searchURL = window.location.search
    const inputWebinarGrade = select(INPUT_WEBINAR_GRADE, body)
    const inputResourceGrade = select(INPUT_RESOURCE_GRADE, body)
    const formFilterSidebar = select(FORM_FILTER_SIDEBAR, body)

    const getCurrentOption = function() {
        let selectedIndex = getProp('selectedIndex', selectEl)
        return options[selectedIndex]
    }
    const getCurrentText = function() {
        let currentOption = getCurrentOption()
        return getProp('text', currentOption)
    }
    const setCurrentText = function() {
        let currentText = getCurrentText()
        setProp('innerHTML', currentText, selectCurrentEl)
    }
    if (getProp('name', selectEl) === 'grades') {
      on('change', () => {
        if (searchURL) {
          window.location = currentURL + selectEl.value + searchURL
        } else {
          window.location = currentURL + selectEl.value
        }
      }, selectEl)
    }

    if (getProp('name', selectEl) === 'webinar_grade' && inputWebinarGrade && formFilterSidebar) {
      on('change', () => {
        inputWebinarGrade.value = selectEl.value
        formFilterSidebar.submit()
      }, selectEl)
    }

    if (getProp('name', selectEl) === 'resource_grade' && inputResourceGrade && formFilterSidebar) {
      on('change', () => {
        inputResourceGrade.value = selectEl.value
        formFilterSidebar.submit()
      }, selectEl)
    }

    setCurrentText()
}
